import request from '@/utils/request'

export function fetchViewList (query) {
  return request({
    url: '/card/api/card_group_view/index',
    method: 'get',
    params: query
  })
}

export function fetchView (id) {
  return request({
    url: '/card/api/card_group_view/view',
    method: 'get',
    params: { id }
  })
}

export function createView (data) {
  return request({
    url: '/card/api/card_group_view/insert',
    method: 'post',
    data
  })
}

export function updateView (data) {
  return request({
    url: '/card/api/card_group_view/update',
    method: 'post',
    data
  })
}

export function deleteView (id) {
  return request({
    url: '/card/api/card_group_view/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/group-view.js